import {useEffect} from 'react';
import doMetric from '../../../v2/tracking/bigQueryMetricRecorder';
import {getCookie} from '../../../v2/utils/cookie-monster';
import Track from '../../../v2/utils/tracking';
import UvLazyLoader from './UvLazyLoader';

export default (props) => {
  const emitEvents = () => {
    const languageLocale = props.locale;
    const siteCountry = languageLocale?.split('-')?.[1]?.toUpperCase() || props.order?.deliveryAddress?.countryCode;
  
    const ecView = {
      type: 'confirmation',
      language: languageLocale,
      country: siteCountry,
      currency: props.orderTotal?.currencyCode,
    };
  
    // Ely 1 uses customerId but Ely 2 has no concept of customerId hence the use of chumewe_user cookie
    const ecUser = {
      user: {
        id: getCookie('chumewe_user'),
      },
    };
  
    const ecBasketItemTransactionEvents = props.order.basketItems.length ? (
      props.order.basketItems.map(basketItem => ({
        product: {
          productId: basketItem?.masterProductId || basketItem?.productId,
          sku: basketItem?.productId || basketItem?.masterProductId,
          name: basketItem?.productTitle,
          price: {
            value: basketItem?.chargePricePerUnit?.value, // unit price charged
            currency: basketItem?.chargePricePerUnit?.currencyCode,
          },
          originalPrice: {
            value: basketItem?.itemPrice?.value, // unit price before discount from discount code only code
            currency: basketItem?.itemPrice?.currencyCode,
          },
        },
        quantity: basketItem?.quantity,
        subtotal: {
          value: basketItem?.totalItemPrice?.value, // quantiy * unit price
          currency: basketItem?.totalItemPrice?.currencyCode,
        },
        subtotalIncludingTax: {
          value: basketItem?.totalItemPrice?.value, // quantiy * unit price pre discount
          currency: basketItem?.totalItemPrice?.currencyCode,
        },
        transaction: {
          id: props.orderNumber,
        },
      }))) : ([]);
  
    const ecBasketTransactionSummary = {
      basket: {
        id: props.orderNumber,
        total: {
          value: props.orderTotal?.value,
          currency: props.orderTotal?.currencyCode,
        },
        quantity: props.order?.basketItemCount,
      },
      transaction: {
        id: props.orderNumber,
      },
    };
  
    if (window.uv?.emit) {
      window.uv?.emit('ecView', ecView);
  
      window.uv?.emit('ecUser', ecUser);
  
      if (ecBasketItemTransactionEvents) {
        ecBasketItemTransactionEvents.forEach((ecBasketItemTransactionEvent) => {
          window.uv?.emit('ecBasketItemTransaction', ecBasketItemTransactionEvent);
        });
      }
  
      window.uv?.emit('ecBasketTransactionSummary', ecBasketTransactionSummary);
    } else {
      Track.error('window.uv or window.uv.emit not present, unable to emit events to UV for Qubit');
    }
    
    if (props.qubitApiIntegrationLoggingEnabled) {
      try {
        doMetric(
          'qubitEvents',
          [
            {name: 'ecView', value: JSON.stringify(ecView)},
            {name: 'ecUser', value: JSON.stringify(ecUser)},
            {name: 'ecBasketItemTransactionEvents', value: JSON.stringify(ecBasketItemTransactionEvents)},
            {name: 'ecBasketTransactionSummary', value: JSON.stringify(ecBasketTransactionSummary)},
          ],
          [],
          'impression',
        );
      } catch (e) {
        Track.error(`Failed to send UV events to bigquery ${e}`);
      }
    }
  };
  
  useEffect(() => {
    if (props.qubitApiIntegrationEnabled) {
      if (window.uv) {
        try {
          emitEvents();
        } catch (e) {
          Track.error(`Error sending events to UV for Qubit ${e}`);
        }
      } else {
        UvLazyLoader()
          .then((createUv) => {
            try {
              window.uv = createUv.default();
              emitEvents();
            } catch (e) {
              Track.error(`Error creating Uv on window or sending events to UV for Qubit ${e}`);
            }
          });
      }
    }
  }, []);
};
